module.exports = __webpack_public_path__ + "static/media/kominfo-syarat-psre.74ab58c6.png";